import React from "react";
import "./sticky-sidebar.m.css";

const StickySidebar = ({ children, left0 = false }) => {
  return <div styleName={`sticky-sidebar ${left0 ? "left0" : ""}`}>{children}</div>;
};

export default StickySidebar;
